import { render } from "./Badges.vue?vue&type=template&id=85f3cc74&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import "../../../../../../css/components/DetallesProducto/badges.css?vue&type=style&index=0&id=85f3cc74&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f3cc74"]])

export default __exports__